// extracted by mini-css-extract-plugin
export default {"card":"card_card__2fn6K","shimmer":"card_shimmer__Xii3G"};